module.exports = __webpack_public_path__ + "img/meal.af0e00a6.jpg";